import { Component } from 'react';
import type { ErrorInfo, FC } from 'react';
import './index.scss';
import crashImg from './imgs/img_crash.png';
import { useTranslation } from 'react-i18next';

// 提前加载图片
const downloadImg = (src: string):HTMLImageElement  => {
  const image = new Image();
  image.onload = function () {
    console.log('图片加载成功')
  }
  image.src = src;
  return image
}
const img = downloadImg(crashImg);
interface Iprops {
  error: Error
}

export const ErrorBoundaryUI: FC<Iprops> = ({ error }) => {
  const { t } = useTranslation('errorBoundary');
  return (
    <div className='error-Boundary-ui-container'>
      <img className='crash-img' src={img.src} alt="" />
      <p className='crash-title'>{t('title')}</p>
    </div>
  )
}

export class ErrorBoundary extends Component<any, { hasError: boolean | null, error: Error | null }> {
  constructor(props: any) {
    super(props);
    this.state = {
      error: null,
      hasError: false
    };
  }

  static getDerivedStateFromError(error: Error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return {
      error,
      hasError: true
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 此处可以上传错误日志给服务器
    console.log(error, errorInfo.componentStack)
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError && error) {
      // 你可以自定义降级后的 UI 并渲染
      return (
        <ErrorBoundaryUI error={error} />
      );
    }

    return this.props.children;
  }
}


